import React from 'react';
import { AlertColor, Snackbar } from '@mui/material';
import { Alert } from '@insights-ltd/design-library/components';

const JobSnackbar = ({
  open,
  reset,
  severity,
  children,
}: {
  open: boolean;
  reset: () => void;
  severity?: AlertColor;
  children: React.ReactNode;
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={reset}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert elevation={6} variant="filled" onClose={reset} severity={severity}>
        {children}
      </Alert>
    </Snackbar>
  );
};

export default JobSnackbar;
